import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { useMemo } from 'react';
import useUser from './hooks/use-user';

export type ActivityType = 'passage_view' | 'context_view' | 'reading_view' | 'search' | 'guided_study_step' | 'manuscript_mark';

export interface ActivityLog {
    type: ActivityType;
    description: string;
    metadata?: Record<string, any>;
    path: string;
    timestamp: any;
}

/**
 * Log a user activity to Firestore
 */
export async function logUserActivity(userId: string, type: ActivityType, description: string, metadata?: Record<string, any>) {
    try {
        const db = getFirestore(getApp());
        const activityRef = collection(db, 'users', userId, 'activity');

        await addDoc(activityRef, {
            type,
            description,
            metadata: metadata || {},
            path: window.location.pathname,
            timestamp: serverTimestamp(),
        });
    } catch (error) {
        console.error('Failed to log user activity:', error);
    }
}

/**
 * Hook for logging user activity
 */
export function useActivityLogger() {
    const { user } = useUser();

    return useMemo(() => ({
        log: (type: ActivityType, description: string, metadata?: Record<string, any>) => {
            if (user?.uid) {
                logUserActivity(user.uid, type, description, metadata);
            }
        }
    }), [user?.uid]);
}
